const EmailChannelConst = {
  model: "emailChannelsCursor",
  routePath: "channels",
};

export default EmailChannelConst;
